// extracted by mini-css-extract-plugin
export default {"auth":"Login_auth__1ADGu","control":"Login_control__81Lsz","actions":"Login_actions__UG8uY","toggle":"Login_toggle__f0NH2"};